import React, { useState, useEffect, useCallback } from "react";
import "./style.less";
import { Modal, Input, Radio, Button } from "semantic-ui-react";
import { useSelector, useDispatch } from "react-redux";
import { useInput } from "../../../common/hooks";
import {
  setWarningWhileTransfer,
  validateTransferTasks,
  setRmBuddiesSearchQueryFilter,
  transferRmBuddyTask
} from "../../../redux/rm-buddies/actions";

import { setErrorToastMessage } from "../../../redux/geofence/actions";
import WarningPopup from "../../../common/components/WarningPopup";

function TransferTaskButton({
  taskIds,
  text,
  onTransferAction,
  onSuccessAction,
  style,
  taskAssignedTo
}) {
  const dispatch = useDispatch();
  const [showSuggested, setShowSuggested] = useState(false);
  const getSuggestedTransferBuddies = () => {
    setShowSuggested(true);
  };
  const [selectedBuddyId, setSelectedBuddyId] = useState();
  const visibleRmBuddiesList = useSelector(
    ({ rmBuddies }) => rmBuddies.visibleRmBuddiesList
  );

  const warnings = useSelector(({ rmBuddies }) => rmBuddies.transferWarnings);

  const closeWarningPopup = useCallback(() => {
    dispatch(setWarningWhileTransfer(null));
  }, [dispatch]);

  const cancelTransferTask = useCallback(() => {
    closeWarningPopup();
    dispatch(setErrorToastMessage("You cancelled transfer"));
  }, [dispatch, closeWarningPopup]);

  const continueWithTransfer = useCallback(() => {
    closeWarningPopup();
    dispatch(
      transferRmBuddyTask({
        buddyTaskIds: taskIds,
        rmBuddyId: selectedBuddyId,
        onTransferAction,
        onSuccessAction
      })
    );
    setSelectedBuddyId(false);
  }, [
    closeWarningPopup,
    dispatch,
    onSuccessAction,
    onTransferAction,
    taskIds,
    selectedBuddyId,
    setSelectedBuddyId
  ]);

  const transferTask = () => {
    dispatch(
      validateTransferTasks({
        buddyTaskIds: taskIds,
        rmBuddyId: selectedBuddyId,
        onTransferAction,
        onSuccessAction
      })
    );
    setShowSuggested(false);
  };
  const [searchInputVal, setSearchInputVal] = useInput("");

  useEffect(() => {
    dispatch(setRmBuddiesSearchQueryFilter(searchInputVal));
  }, [dispatch, searchInputVal]);
  return (
    <span className="TransferTaskButton">
      <WarningPopup
        open={warnings && warnings.length > 0}
        warningMsgArr={warnings}
        onOk={continueWithTransfer}
        onCancel={cancelTransferTask}
      />
      <Button primary onClick={getSuggestedTransferBuddies} style={style}>
        {text}
      </Button>
      <Modal
        className="SuggestedBuddies"
        size="mini"
        open={showSuggested}
        closeOnEscape={true}
        closeOnDimmerClick={true}
        onClose={() => {
          setSelectedBuddyId(null);
          setShowSuggested(false);
        }}
      >
        <Modal.Content>
          <Input
            fluid
            icon="search"
            placeholder="Enter name"
            value={searchInputVal}
            onChange={setSearchInputVal}
          />
          <br />
          <div className="SuggestedBuddiesList">
            {visibleRmBuddiesList &&
              visibleRmBuddiesList
                .filter(
                  e => taskAssignedTo.find(t => t._id === e._id) === undefined
                )
                .map(e => (
                  <div>
                    <Radio
                      checked={e._id === selectedBuddyId}
                      onClick={() => setSelectedBuddyId(e._id)}
                      label={
                        <label>
                          <span className="transferName">{e.name}</span>
                          <br />
                          <span className="">{e.phone_num}</span>
                          <br />
                          {e.task_count} tasks
                        </label>
                      }
                    />
                    <br />
                  </div>
                ))}
          </div>
          <Button
            disabled={!selectedBuddyId}
            size="mini"
            primary
            onClick={transferTask}
          >
            {" "}
            Done{" "}
          </Button>
        </Modal.Content>
      </Modal>
    </span>
  );
}
TransferTaskButton.defaultProps = {};

TransferTaskButton.propTypes = {};

export default TransferTaskButton;
